<template>
  <div class="w-full p-2">
    <div
      class="w-full bg-blue-100 px-3 py-2 rounded-lg flex justify-between items-center max-w-1200 mx-auto shadow"
    >
      <div class="hidden md:block text-blue-400 font-normal">
        {{ copy.scheduleCall }}
      </div>
      <Button
        :text="
          ['md', 'lg', 'xl'].includes($mq)
            ? copy.buttonDesktop
            : copy.buttonMobile
        "
        :short="true"
        emphasis="medium"
        color="blue"
        textColor="text-blue-400"
        class="flex-1 md:flex-none"
        @click="$emit('click', $event)"
      />
    </div>
  </div>
</template>

<script>
import { Button } from '@sportsrecruits/playbook';
export default {
  components: {
    Button,
  },
  data: () => ({
    copy: {
      scheduleCall: "Need Help? Schedule a call to find the right fit for you.",
      buttonMobile: "Schedule a Call to Find the Right Fit",
      buttonDesktop: "Schedule a Call",
    },
  }),
};
</script>

<style>
</style>
